import "./PoweredBy.scss";
import { LegalLinks } from "../LegalLinks";

export function PoweredBy({ modalOpen, delay = 0.5, duration = 2 }) {
	return (
		<div
			className={`powered-by ${modalOpen ? "powered-by--modal-open" : ""}`}
			style={{ "--delay": `${delay}s`, "--duration": `${duration}s` }}>
			<div className="powered-by__inner">
				<p>
					<a href="https://atelier.net/" target="_blank" rel="noreferrer">
						Powered by
						<br />
						L'Atelier BNP Paribas
					</a>
				</p>
				<div className="powered-by__legal-links">
					<LegalLinks />
				</div>
			</div>
		</div>
	);
}
